import ApiService from '../../../../shared/services/ApiService';

export default {

    getJobCodes() {
        return ApiService.get('company-jobs');
    },

    saveJobCodes(data) {
        return ApiService.post('company-jobs-multi', data);
    },

    updateJobCode(id, data) {
        return ApiService.put(`company-jobs/${id}`, data);
    },

    deleteJobCode(id) {
        return ApiService.delete(`company-jobs/${id}`);
    }

}